/**
 * assets/homepage-hero.js
 * Self-contained hero slideshow: auto-advance with fade, clickable dots,
 * pause on hover/touch. Isolated custom element — no dependency on
 * Dawn's cart internals, no shared globals, zero risk to other components.
 */
(function () {
  if (customElements.get('hero-slideshow')) return;

  class HeroSlideshow extends HTMLElement {
    constructor() {
      super();
      this.images = Array.from(this.querySelectorAll('.hero__image'));
      this.dots = Array.from(this.querySelectorAll('.hero__dot'));
      this.currentIndex = 0;
      this.intervalMs = parseInt(this.dataset.autoplayMs, 10) || 6000;
      this.timer = null;

      this.goToSlide = this.goToSlide.bind(this);
      this.next = this.next.bind(this);
    }

    connectedCallback() {
      if (this.images.length <= 1) return;

      this.dots.forEach((dot) => {
        dot.addEventListener('click', () => {
          const index = parseInt(dot.dataset.slideIndex, 10);
          this.goToSlide(index);
          this.restartTimer();
        });
      });

      this.addEventListener('mouseenter', () => this.stopTimer());
      this.addEventListener('mouseleave', () => this.startTimer());

      this.startTimer();
    }

    disconnectedCallback() {
      this.stopTimer();
    }

    goToSlide(index) {
      if (index === this.currentIndex) return;
      this.images[this.currentIndex].classList.remove('is-active');
      this.dots[this.currentIndex] && this.dots[this.currentIndex].classList.remove('is-active');

      this.currentIndex = index;

      this.images[this.currentIndex].classList.add('is-active');
      this.dots[this.currentIndex] && this.dots[this.currentIndex].classList.add('is-active');
    }

    next() {
      const nextIndex = (this.currentIndex + 1) % this.images.length;
      this.goToSlide(nextIndex);
    }

    startTimer() {
      this.stopTimer();
      this.timer = setInterval(this.next, this.intervalMs);
    }

    stopTimer() {
      if (this.timer) clearInterval(this.timer);
    }

    restartTimer() {
      this.startTimer();
    }
  }

  customElements.define('hero-slideshow', HeroSlideshow);
})();